import CarDetail from './CarDetail';
export default CarDetail;
